import ProductCard from '@/entities/ProductCard/index.js'
import { ProductContent } from './ProductContent.jsx'

export const CatalogItems = ({ items, configRequest, productsInCart }, ref) => {
    const safeItems = Array.isArray(items) ? items : []

    return (
        <div className="CatalogItems goods-container">
            <h1>{configRequest.namePage}</h1>
            <div className="items">
                {safeItems.length > 0 ? (
                    safeItems.map((item) => (
                        <ProductCard
                            {...item}
                            key={item.product_id}
                            nameNode={
                                <h3 role="button" className="title">
                                    {item.name}
                                </h3>
                            }
                        >
                            <ProductContent
                                item={item}
                                productsInCart={productsInCart}
                            />
                        </ProductCard>
                    ))
                ) : (
                    <p>Товары не найдены :(</p>
                )}
            </div>
        </div>
    )
}
